import { CheckSolid } from '@ecomm/shared-icons'

export function Benefit({ text }: { readonly text: string }) {
  return (
    <li className="flex align-center">
      <CheckSolid className="text-complementary-green-100 h-6 w-6 mr-0.5 mt-0.5 shrink-0" />
      <span className="text-left">{text}</span>
    </li>
  )
}
